import {useFetchEntries} from 'hec/hooks/useFetchEntries'
import {getConfig} from '@salesforce/pwa-kit-runtime/utils/ssr-config'
import modelMap from 'hec/builder/model-map'

export const useSitePrefs = () => {
    const config = getConfig()
    const {data} = useFetchEntries({
        queryKey: ['Fetch-Site-Preferences'],
        options: {
            model: modelMap.sitePreferences,
            apiKey: config.app.builder.api,
            fields: 'data'
        }
    })

    return data ? data[0].data : {}
}
